import { action } from 'typesafe-actions';
import { DocumentTypes } from './types';

export const documentsRequest = (company: any) =>
  action(DocumentTypes.DOCUMENTS_RESQUEST, { company });

export const documentsSuccess = (data: any) =>
  action(DocumentTypes.DOCUMENTS_SUCCESS, { data });

export const documentsFailure = () =>
  action(DocumentTypes.DOCUMENTS_FAILURE, {});
